import React from "react";

const Logo = ({ size }) => {
  return (
    <div
      className={`flex items-end text-purple-700 ${
        size === "small" ? "h-12" : "h-24"
      } relative`}
    >
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 1024.000000 1024.000000"
        preserveAspectRatio="xMidYMid meet"
      >
        <g
          transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)"
          fill="#7E22CD"
          stroke="none"
        >
          <path
            d="M5154 9258 c-39 -19 -44 -49 -44 -283 l0 -225 -85 0 -85 0 0 68 c0
    77 -15 107 -64 127 -42 18 -81 8 -111 -27 -21 -25 -25 -40 -25 -99 l0 -69
    -314 0 c-197 0 -324 -4 -344 -11 -34 -12 -62 -47 -62 -79 0 -20 80 -291 175
    -595 48 -152 95 -314 95 -327 0 -4 -55 -9 -122 -10 l-123 -3 -3 -102 -3 -102
    33 -6 c18 -3 542 -4 1163 -3 l1130 3 0 105 0 105 -117 3 c-85 2 -118 6 -118
    15 1 24 39 158 150 517 62 201 115 372 117 381 7 25 -24 77 -57 94 -24 12 -82
    15 -345 15 l-315 0 0 69 c0 60 -3 74 -26 100 -22 27 -33 31 -73 31 -70 0 -94
    -29 -101 -123 l-5 -72 -87 -3 -88 -3 0 226 c0 229 -4 255 -39 282 -19 15 -78
    16 -107 1z m-385 -890 c7 -62 21 -194 31 -293 11 -99 22 -197 24 -217 l4 -38
    -163 0 c-147 0 -164 2 -169 18 -56 188 -176 624 -176 638 0 2 98 4 219 4 l218
    0 12 -112z m668 65 c-3 -27 -18 -175 -33 -331 l-28 -282 -171 2 -170 3 -32
    310 c-17 171 -32 318 -32 328 -1 16 17 17 235 17 l237 0 -6 -47z m653 43 c0
    -2 -23 -89 -50 -192 -28 -104 -67 -251 -87 -326 l-36 -138 -164 0 -163 0 0 38
    c0 20 14 169 32 330 l31 292 219 0 c120 0 218 -2 218 -4z"
          />
          <path
            d="M3863 7520 c-38 -15 -43 -41 -43 -225 0 -173 0 -176 25 -200 20 -21
    34 -25 85 -25 l61 0 -3 -152 -3 -153 -61 -5 c-93 -7 -104 -22 -104 -131 0 -83
    1 -89 26 -108 l27 -21 1331 0 c1051 0 1336 3 1356 13 24 12 25 18 28 103 4
    118 -8 136 -95 142 l-60 4 -7 61 c-8 77 -8 176 0 216 6 30 9 31 54 31 103 0
    110 16 110 240 0 168 0 171 -25 195 -32 32 -100 35 -138 5 -23 -18 -26 -29
    -29 -93 l-3 -72 -640 1 c-352 0 -886 2 -1187 2 l-547 2 -6 58 c-3 31 -11 67
    -17 79 -18 36 -86 53 -135 33z m607 -605 l0 -155 -145 0 -145 0 0 155 0 155
    145 0 145 0 0 -155z m580 0 l0 -155 -139 0 c-77 0 -142 4 -145 9 -4 5 -3 75 0
    155 l7 146 139 0 138 0 0 -155z m600 0 l0 -155 -145 0 -145 0 0 155 0 155 145
    0 145 0 0 -155z m580 0 l0 -155 -145 0 -145 0 0 155 0 155 145 0 145 0 0 -155z"
          />
          <path
            d="M3990 6323 c0 -5 13 -31 30 -59 35 -62 103 -123 187 -171 l63 -35 0
    -131 0 -131 -189 -425 c-104 -234 -269 -601 -366 -816 -97 -214 -215 -475
    -262 -580 -47 -104 -114 -252 -149 -328 -35 -76 -64 -140 -64 -143 0 -2 -68
    -151 -151 -331 -148 -321 -314 -683 -509 -1113 -54 -118 -126 -276 -160 -350
    -34 -74 -64 -141 -67 -148 -4 -10 118 -12 608 -10 l613 3 86 200 c48 110 146
    341 219 513 l133 312 1202 0 1201 -1 114 -272 c63 -150 139 -330 169 -402 30
    -71 75 -179 101 -240 l47 -110 602 -3 c331 -1 602 0 602 3 0 8 -390 877 -570
    1270 -80 174 -158 347 -500 1110 -37 83 -120 267 -185 410 -64 143 -146 325
    -182 405 -36 80 -90 199 -120 265 -100 219 -265 589 -309 693 -44 104 -44 104
    -44 227 l0 124 68 35 c95 51 158 108 193 177 l29 59 -1220 0 c-671 0 -1220 -3
    -1220 -7z m1293 -1088 c36 -82 111 -260 167 -395 56 -135 183 -436 282 -670
    99 -234 203 -479 230 -545 27 -66 52 -126 55 -132 4 -10 -161 -13 -806 -13
    -446 0 -811 2 -811 4 0 2 23 58 51 123 28 65 113 269 190 453 77 184 153 364
    168 400 41 93 204 482 266 635 88 218 128 306 136 298 4 -5 37 -75 72 -158z"
          />
        </g>
      </svg>
      <p
        className={`font-bold text-purple-700    ${
          size === "small" ? "text-xs -ml-2 mb-1 " : "-ml-4 mb-2"
        }`}
      >
        eroWatch
      </p>
    </div>
  );
};

export default Logo;
